module.exports = __webpack_public_path__ + "media/bookPage/4-bd4ea4a4.jpeg";